import React from 'react';
import { getAssetPath } from '../../utils/assetHelper';
import './NotificationsPanel.scss';

/**
 * NotificationsPanel component
 * 
 * Renders the notification panel on the right side of the dashboard,
 * matching the design from the original HTML/CSS.
 */
const NotificationsPanel: React.FC = () => {
  return (
    <div className="c-notifications">
      <h6 className="c-notifications__title new">Recent <span>2</span></h6>
      <div className="c-notifications__alert new">
        <h4>
          <img src={getAssetPath('assets/images/c-notifications-icon.png')} alt="" />
          New Challenge
          <span></span>
        </h4>
        <p>Behavioural targeting, in today's thinking, accelerates activity monitoring</p>
        <small>Today, at 5pm</small>
        <div className="c-notifications__alert-flash">
          <video src={getAssetPath('assets/images/flash.mp4')} autoPlay loop muted playsInline></video>
        </div>
      </div>
      <div className="c-notifications__alert new">
        <h4>
          <img src={getAssetPath('assets/images/c-notifications-icon.png')} alt="" />
          Valor Points Earned
          <span></span>
        </h4>
        <p>You've earned 250 Valor Points for completing the daily challenge!</p>
        <small>Today, at 3pm</small>
        <div className="c-notifications__alert-flash">
          <video src={getAssetPath('assets/images/flash.mp4')} autoPlay loop muted playsInline></video>
        </div>
      </div>
      <h6 className="c-notifications__title">OLDEST</h6>
      <div className="c-notifications__alert">
        <h4>
          <img src={getAssetPath('assets/images/c-notifications-icon.png')} alt="" />
          Security Update
        </h4>
        <p>Important security update: Please review your account settings</p>
        <small>Yesterday, at 2pm</small>
      </div>
      <div className="c-notifications__alert">
        <h4>
          <img src={getAssetPath('assets/images/c-notifications-icon.png')} alt="" />
          New Event Coming
        </h4>
        <p>Get ready for the upcoming 'Battle of the Realms' event!</p>
        <small>2 days ago</small>
      </div>
    </div>
  );
};

export default NotificationsPanel; 